import en from '../../app/data/i18n.en.json';

angular.module('services.defaultI18n', []).constant('defaultI18n', { en });
